module.exports = __webpack_public_path__ + "img/normal_icon_06.07d0d1e.png";